// ********** Config ********** //
export const CONFIG = 'config-client-file';

// ********** Register ********** //
export const CUSTOMER_REQUESET_REGISTERATION = 'customer/request-registration';
export const CUSTOMER_RESEND_OTP = 'customer/registration-resend-otp';
export const CUSTOMER_VALIDATE_OTP_CREATE_USER = 'customer/validate-otp-create-user';

// ********** Login ********** //
export const CUSTOMER_LOGIN = 'oauth/access_token';

// ********** Login With Otp ********** //
export const CUSTOMER_LOGIN_WITH_OTP = 'reset-request-otp';
export const CUSTOMER_VERIFY_OTP = 'validate-reset-otp';

// ********** Login With Mobile Otp ********** //
export const CUSTOMER_LOGIN_WITH_MOBILE_OTP = 'v3/oauth/otp/send';

// ********** Set New Password ******** //
export const SET_NEW_PASSWORD = 'reset-password/using-otp';

// ********** Forgot New Password ******** //
export const RESET_PASSWORD = 'reset-password';
export const CHANGE_PASSWORD = 'change-password';

// ********* Update Password ********** //
export const UPDATE_PASSWORD = 'password/change';

// ********** Verify SignUp ******** //
export const IS_VERIFY_EMAIL_VERIFIED = 'isEmailVerified?request_id=';
export const RESEND_EMAIL_VERIFICATION = 'resendEmailVerificationToken?request_id=';

// ********** User ********** //

export const GET_CURRENT_USER_DETAILS = 'v3/user_management/new_user_register';
export const GET_CURRENT_USER = 'v3/consumer/current-user';
export const GET_EMPLOYEE_DETAILS = 'users/getEmployeeDetails';
export const SET_EMPLOYEE_DETAILS = 'users/setEmployeeDetails';
export const UPDATE_MOBILE_NUMBER = 'v3/consumer/update_mobile_number';
export const VALIDATE_MOBILE_NUMBER = 'v3/consumer/validate_mobile_number';

// ********** Cafeteria ********** //

export const SET_DEFAULT_CAFETERIA = 'user/set_default_location';

// ********** Company ********** //

export const UPDATE_COMPANY = 'v3/consumer/company/';

// ********** Occasion ********** //

export const GET_OCCASIONS = 'v3/consumer/list-occasions';

// ********** Banners ********** //

export const GET_BANNERS = 'v2/getBannersForHome';

// ********** Vendor ********** //

export const GET_VENDORS = 'listVendors/';

// ********** Bookmarks ********** //

export const GET_BOOKMARKS = 'v3/consumer/bookmarks';

export const ADD_BOOKMARKS = 'v3/consumer/bookmarks';

export const REMOVE_BOOKMARKS = 'v3/consumer/bookmarks';

// ********** Menu ********** //

export const GET_MENU = 'v3/menu/employee/list-menu';

// ********** Cart ********** //

export const GET_CART = 'v3/cart/get';

export const CREATE_CART = 'v3/cart/create';

export const UPDATE_CART = 'v3/cart/edit/';

export const DELETE_CART = 'v3/cart/delete';

export const LIST_RECOMMENDED_MENU = 'v3/menu/employee/list-recommended-menu';

// ********** ETA ********** //

export const GET_ETA = 'v3/consumer/order/eta';

// ********** Address ********** //
export const GET_ADDRESS = 'v3/user_management/list_user_addresses';

export const EDIT_ADDRESS = 'v3/user_management/edit_address';

export const DELETE_ADDRESS = 'v3/user_management/delete_address';

// ********** Add Guest ********** //
export const ADD_GUEST = 'guest/create-by-employee';

export const GET_GUEST_LIST = 'getGuestList/';

// ********** Wallets ********** //
export const WALLET_HISTORY = 'wallet-history';
export const ARCHIVED_WALLET_HISTORY = 'archived-wallet-history';
export const WALLET_FILTER_LIST = 'wallet-filter-list';
export const RECHARE_WALLET = 'user/recharge';
export const JUSPAY_RECHARGE_WALLET = 'juspay-wallet/recharge';
export const PAYTM_RECHARGE_WALLET = 'paytm-direct/recharge';

export const WALLET_LIST = 'v2/wallet-list';

export const DELINK_INTERNAL_WALLET = 'delink-internal-wallet';
export const DELINK_WALLET = 'delink-wallet';

export const INITIATE_JUSPAY_LINKING = 'juspay-wallet/initiate-linking';
export const INITIATE_LINKING = 'simpl/access-token/initiate';

export const VALIDATE_JUSPAY_LINKING = 'juspay-wallet/validate-linking';
export const VALIDATE_LINKING = 'simpl/access-token/validate-otp';
export const JUSPAY_WALLET_PAYMENT = 'juspay-wallet-payment';

// ********** Payment ********** //

export const VALIDATE_VPA = 'validate_vpa?';
export const UPDATE_EXTERNAL_PAYMENT_STATUS = 'v3/consumer/employee/external-payment-status';

// ********** Card ********** //

export const ADD_CARD = 'juspay-card/add';

export const DELETE_SAVED_CARD = 'delete-saved-card';

// ********** NetBanking ********** //

export const GET_NETBANKING_LIST = 'listNetbanking';

// ********** Group Ordering User ********** //

export const ADD_GROUP_ORDERING_USER = 'users/allowed-in-group-order';

// ********** Order ****************//

export const ORDER_HISTORY = 'v3/consumer/employee/order-list';

export const ORDER_DETAILS = 'v3/consumer/employee/order-details';

export const RECENT_ORDERS = 'v3/consumer/employee/recent-orders';

export const CREATE_ORDER = 'v3/consumer/create-order';

export const DOWNLOAD_INVOICE = 'order/download-invoice';

export const SEND_INVOICE = 'order/send-invoice';

export const CANCELLATION_ELIGIBILITY = 'order/cancellation-eligibility';

export const CANCEL_ORDER = 'external/order-status-update';

export const CANCEL_ORDER_V2 = 'order/cancellation';

export const CANCELLATION_REASONS = 'v3/consumer/employee/cancellation-reasons';

export const ENTER_CAFE = 'cafe/entry';

export const EXIT_CAFE = 'cafe/exit';

export const PLACE_ORDER_SLOT_BOOKING = 'order_place/';

export const ARCHIVED_ORDERS = 'v3/consumer/employee/order-list-archived';

// ********** Help ****************//

export const HELP_MENU_ITEMS = 'support/getQuestions/Help';

// ********** Global Search ****************//

export const GLOBAL_SEARCH = 'v3/consumer/search';

export const LIST_MENU_SEARCH = 'list-menu-search-results';

// ********** Rate Order ****************//

export const RATE_ORDER_OPTIONS = 'v3/consumer/employee/review/options';

export const RATE_ORDER = 'v3/consumer/employee/order/review';

// ********** Logout ****************//

export const LOGOUT = 'logout';

export const UPDATE_GUEST_REGISTRATION_REQUEST_VIA_MAIL =
  'v3/guest_ordering_v2/update-guest-request-status-from-mail';

export const SEND_VALIDATION_OTP_FOR_APPROVAL_ACTION =
  'v3/approval_management/send-authorisation-otp';

// ********** OPEN_ORDER QR Data ****************//

export const OPEN_ORDER_ORDER_DETAILS = 'v3/consumer/get-qr-data';

export const OPEN_ORDER_DOWNLOAD_INVOICE = 'v2/order/download-invoice';

export const OPEN_ORDER_SEND_INVOICE = 'v2/order/send-invoice';
